import { ShowSingleJob } from "./showSingleJob";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchSingleJob } from "../../../store/thunks/single-job";
import { setFavourite } from "../../../store/actions/favourite-actions";
import { resetSingleJob } from "../../../store/actions/single-job-actions";

const mapStateToProps = state => {
  return {
    job: state.singleJobState.customerservice,
    favourited: state.favouriteState.favourites,
    pageTitle: `${state.singleJobState.customerservice &&
      state.singleJobState.customerservice.title} - ${state.singleJobState
      .customerservice &&
      state.singleJobState.customerservice.company_name} - Just Remote`,
    pageDesc: `${state.singleJobState.customerservice &&
      state.singleJobState.customerservice
        .company_name} are looking for a ${state.singleJobState
      .customerservice &&
      state.singleJobState.customerservice.title}! The role is ${state
      .singleJobState.customerservice &&
      state.singleJobState.customerservice
        .remote_type} and they're looking for applicants immediately. Find out more and apply today. No sign up required!`
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchSingleJob: bindActionCreators(fetchSingleJob, dispatch),
    handleFavouriteClick(job) {
      dispatch(setFavourite(job));
    },
    resetSingleJob: () => {
      dispatch(resetSingleJob());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowSingleJob);
